/**
 * Поля формы «Загружен в предархив»: получатели и четыре редактируемых поля + комментарий.
 */
import { useRef } from 'react';
import { UserRecipientCombo, type RecipientUserItem } from '@/components/UserRecipientCombo/UserRecipientCombo';
import { Input } from '@/components/ui/Input/Input';
import { Textarea } from '@/components/ui/Textarea/Textarea';
import { TimeInput } from '@/components/ui/TimeInput/TimeInput';
import { Switch } from '@/components/ui/Switch/Switch';

export interface PreArchiveUploadEmailFieldsProps {
  recipients: RecipientUserItem[];
  onRecipientsChange: (items: RecipientUserItem[]) => void;
  ccUsers: RecipientUserItem[];
  onCcUsersChange: (items: RecipientUserItem[]) => void;
  time: string;
  onTimeChange: (value: string) => void;
  tracksCount: string;
  onTracksCountChange: (value: string) => void;
  sizeValue: string;
  onSizeValueChange: (value: string) => void;
  noEdits: boolean;
  onNoEditsChange: (value: boolean) => void;
  commentNote: string;
  onCommentNoteChange: (value: string) => void;
  disabled?: boolean;
}

export function PreArchiveUploadEmailFields({
  recipients,
  onRecipientsChange,
  ccUsers,
  onCcUsersChange,
  time,
  onTimeChange,
  tracksCount,
  onTracksCountChange,
  sizeValue,
  onSizeValueChange,
  noEdits,
  onNoEditsChange,
  commentNote,
  onCommentNoteChange,
  disabled,
}: PreArchiveUploadEmailFieldsProps) {
  const recipientRef = useRef<HTMLDivElement>(null);
  const ccComboRef = useRef<HTMLDivElement>(null);

  return (
    <div className="review-check-email-modal__fields">
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={recipients}
          onChange={onRecipientsChange}
          placeholder="Получатель"
          containerRef={recipientRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__field">
        <UserRecipientCombo
          value={ccUsers}
          onChange={onCcUsersChange}
          placeholder="Копия"
          containerRef={ccComboRef}
          disabled={disabled}
        />
      </div>
      <div className="review-check-email-modal__row review-check-email-modal__row_cols-3-switch">
        <div className="review-check-email-modal__field">
          <TimeInput value={time} onChange={onTimeChange} placeholder="00:00:00" fullWidth disabled={disabled} />
        </div>
        <div className="review-check-email-modal__field">
          <Input
            value={tracksCount}
            onChange={(e) => onTracksCountChange(e.target.value.replace(/[^\d]/g, ''))}
            placeholder="Количество треков"
            fullWidth
            disabled={disabled}
          />
        </div>
        <div className="review-check-email-modal__field">
          <Input
            value={sizeValue}
            onChange={(e) => {
              const v = e.target.value.replace(',', '.').replace(/[^\d.]/g, '');
              const parts = v.split('.');
              if (parts.length <= 1) onSizeValueChange(v);
              else onSizeValueChange(parts[0] + '.' + parts.slice(1).join(''));
            }}
            placeholder="Размер (ГБ)"
            fullWidth
            disabled={disabled}
          />
        </div>
        <div className="review-check-email-modal__field review-check-email-modal__field_switch">
          <Switch checked={noEdits} onCheckedChange={onNoEditsChange} disabled={disabled} label="Без правок" />
        </div>
      </div>
      <div className="review-check-email-modal__field">
        <Textarea
          value={commentNote}
          onChange={(e) => onCommentNoteChange(e.target.value)}
          placeholder="Комментарий к письму"
          fullWidth
          minRows={1}
          maxRows={40}
          inputClassName="review-check-email-modal__comment-input"
          disabled={disabled}
        />
      </div>
    </div>
  );
}
